var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NormalHeaderLayout',{attrs:{"header":_vm.$t('disclaimerPage.header')}},[_c('p',[_vm._v(_vm._s(_vm.$t('disclaimerPage.p1')))]),_c('p',[_vm._v(_vm._s(_vm.$t('disclaimerPage.p2')))]),_c('p',[_vm._v(_vm._s(_vm.$t('disclaimerPage.p3')))]),_c('p',[_vm._v(_vm._s(_vm.$t('disclaimerPage.p4')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }